import Grid from '@mui/material/Grid';
import CVDCardGenetics from '../../../../../../components/Cards/CVDCardGenetics';
import CardElements from "../../../../../../components/TextComps/CardElements";
import Disease from "./Disease/Disease";
import Dis_Variants from "./Disease/Dis_Variants";
import Dis_Signal from "./Disease/Dis_Signal";
import Cardio from "./Cardio/Cardio";
import Cardio_Variants from "./Cardio/Cardio_Variants";
import Cardio_Signal from "./Cardio/Cardio_Signal";


export default function Heart() {

return (
<>
<CVDCardGenetics 

cardheadline = 'HEART'
content = {<>
               
                <Grid container> 

                        <CardElements element1={<Disease />} element2={<Dis_Variants />} element3={<Dis_Signal />} />
                        <CardElements element1={<Cardio />} element2={<Cardio_Variants />} element3={<Cardio_Signal />} />
                        
                </Grid> 

    </>}   
    
/>    
</>
)};
